<template>
  <v-card height="auto">
    <vue-card-title
      :title="
        actionData && actionData.slug
          ? 'Update Department and Teams'
          : 'Create Department and Teams'
      "
      :subtitle="
        actionData && actionData.slug
          ? 'Here you can update the existing department and teams.'
          : 'Here you can create new deaprtment and teams.'
      "
      :icon="$getIcon('mdiFileDocumentOutline')"
      closable
      dark
      @close="$emit('close')"
    ></vue-card-title>
    <v-divider></v-divider>
    <v-card-text class="py-4 scrollbar-md">
      <v-row no-gutters class="pa-0 ma-0">
        <v-col v-if="formValidator.getError('non_field_errors')">
          <v-alert shaped outlined text type="error">
            {{ formValidator.getError("non_field_errors") }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="formValues.name"
            label="Name *"
            counter="50"
            :error-messages="formValidator.getError('name')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <vue-auto-complete
            v-model="formValues.parent"
            :endpoint="endpoint"
            label="Parent *"
            :prepend-inner-icon="$getIcon('mdiInformationOutline')"
            :error-messages="formValidator.getError('parent')"
            item-text="name"
            item-value="slug"
          ></vue-auto-complete>
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="formValues.email"
            label="Email"
            counter="50"
            :error-messages="formValidator.getError('email')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="formValues.extension_number"
            label="Extension Number"
            counter="4"
            :error-messages="formValidator.getError('extension_number')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <vue-auto-complete
            v-model="formValues.head"
            :endpoint="TeamHeadEndpoint"
            label="Head"
            :prepend-inner-icon="$getIcon('mdiInformationOutline')"
            :error-messages="formValidator.getError('head')"
            item-text="name"
            item-value="id"
          ></vue-auto-complete>
        </v-col>
        <v-col md="6" cols="12">
          <v-checkbox
            v-model="formValues.is_archived"
            label="Is Archived"
          ></v-checkbox>
        </v-col>
        <v-col md="12" cols="12">
          <vue-users-auto-complete
            v-model="formValues.members"
            :key="key"
            multiple
            label="Select User Involvements"
            :prepend-inner-icon="$getIcon('mdiAccountPlus')"
          >
          </vue-users-auto-complete>
        </v-col>
        <v-col md="12" cols="12">
          <vue-auto-complete
            v-model="formValues.service_categories"
            :key="serviceCategoryKey"
            label="Select service categories"
            :endpoint="serviceCategoryEndpoint"
            :prepend-inner-icon="$getIcon('mdiInformationOutline')"
            item-text="name"
            item-value="id"
            multiple
          >
          </vue-auto-complete>
        </v-col>
        <v-col md="12" cols="12">
          <v-textarea
            v-model="formValues.description"
            label="Description"
            counter="600"
            rows="3"
            :error-messages="formValidator.getError('description')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn text @click="$emit('close')" class="text-capitalize">
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="indigo"
            class="white--text text-capitalize"
            :disabled="loading"
            @click="submit()"
          >
            {{ actionData && actionData.slug ? "Update" : "Create" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  props: {
    actionData: {
      type: [Object, Array],
      default: undefined
    }
  },
  data() {
    return {
      formValues: JSON.parse(JSON.stringify(this.actionData)) || {},
      loading: false,
      formValidator: new FormValidator(),
      TeamHeadEndpoint: `/api/v1/users/?organization__slug=${this.$store.state.shell.currentOrganizationId}&is_archived=false`,
      endpoint: `/api/v1/crm/${this.$store.state.shell.currentOrganizationId}/divisions/?is_archived=false`,
      key: 0,
      serviceCategoryKey: 0,
      serviceCategoryEndpoint: `api/v1/crm/service-categories/?organization__slug=${this.$store.state.shell.currentOrganizationId}`
    };
  },
  watch: {
    "formValues.parent": {
      handler(val) {
        this.serviceCategoryEndpoint = `api/v1/crm/service-categories/?organization__slug=${this.$store.state.shell.currentOrganizationId}&crmdivision__slug=${val}`;
        this.serviceCategoryKey += 1;
        this.formValues.service_categories = [];
      }
    }
  },
  created() {
    if (this.actionData) {
      this.formValues.members = this.actionData.members.map(x => x.id);
      this.key += 1;
    }
  },
  methods: {
    submit() {
      this.actionData && this.actionData.slug
        ? this.updateForm()
        : this.createForm();
    },
    createFormValues() {
      const postData = JSON.parse(JSON.stringify(this.formValues));
      if (!postData.members) {
        postData.members = [];
      }
      if (!postData.service_categories) {
        postData.service_categories = [];
      }
      return postData;
    },
    createForm() {
      this.loading = true;
      let endpoint = `/api/v1/crm/${this.$store.state.shell.currentOrganizationId}/divisions/`;
      this.$axios
        .$post(endpoint, this.createFormValues())
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created Department and Teams.`,
            color: "green"
          });
          this.$emit("create");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateForm() {
      this.loading = true;
      let endpoint = `/api/v1/crm/${this.$store.state.shell.currentOrganizationId}/divisions/${this.actionData.slug}/`;
      this.$axios
        .$put(endpoint, this.createFormValues())
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated Department and Teams.`,
            color: "green"
          });
          this.$emit("update");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
